// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ":root{--spacing-xxs: 2px;--spacing-xs: 4px;--spacing-s: 8px;--spacing-m: 12px;--spacing-l: 16px;--spacing-xl: 24px;--spacing-xxl: 32px;--spacing-xxl-2: 40px;--spacing-xxl-3: 48px;--spacing-xxl-4: 56px;--spacing-xxl-5: 64px;--spacing-xxl-6: 80px}.b2b-lib-errorCard{padding:var(--spacing-xl);display:flex;height:100%;align-items:center;justify-content:center;flex-direction:column;text-align:center}.b2b-lib-errorCard .b2b-lib-refreshInfo{margin-top:18px;color:#555a5a;font-size:12px;font-weight:600;letter-spacing:0.05em;text-align:center}.b2b-lib-errorCard .b2b-lib-refreshText{text-decoration:underline;cursor:pointer}.b2b-lib-errorCard .b2b-lib-refreshText:hover{text-decoration:none}\n", ""]);
// Exports
exports.locals = {
	"errorCard": "b2b-lib-errorCard",
	"refreshInfo": "b2b-lib-refreshInfo",
	"refreshText": "b2b-lib-refreshText"
};
module.exports = exports;
